'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/axios@0.21.4_debug@4.4.3_supports-color@5.5.0_/~/axios/lib/helpers/normalizeHeaderName.js
// module id = ZhUq
// module chunks = 5